import template from "../templates/pages/profile.html?raw";

export default class ProfilePage {
    constructor() {
      this.loadPage();
    }

    public loadPage(): void {
      document.querySelector<HTMLDivElement>("#app")!.innerHTML = template;
    }
  }
